import { render } from "./OneginCottages.vue?vue&type=template&id=7bdd3bcc&scoped=true"
import script from "./OneginCottages.vue?vue&type=script&lang=js"
export * from "./OneginCottages.vue?vue&type=script&lang=js"

import "./OneginCottages.vue?vue&type=style&index=0&id=7bdd3bcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdd3bcc"]])

export default __exports__